module.exports = __webpack_public_path__ + "img/arrow.d648020d.svg";